import TopNav from "ui/dashboard/topnav";
import {
  SvgGPTSearch,
  SvgNGUXImgSearch,
  SvgNGUXLPRSearch,
  SvgTeamAIAgentAGI,
  SvgAutoPilot,
  SvgNGUXMobileSOC,
} from "ui/svgs";
export default function NextGenerationUserExperience() {
  return (
    <div
      className="profile-page flex flex-col items-center h-full mr-6 mb-6"
      style={{ height: "calc(100% - 24px)" }}
    >
      <TopNav title="Next Generation User Experience" />
      <div className="flex flex-col gap-8 items-center w-full overflow-y-auto bg-white rounded-3xl pt-[60px] flex-grow">
        <div className="w-[700px]">
          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-9 items-center">
            <SvgGPTSearch width={30} />
            <p className="font-semibold pl-2 w-[184px]">Magic Search</p>
            <p className="w-[360px] tex-sm">Search Any thing you want</p>
          </div>

          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-9 items-center mt-6">
            <SvgNGUXImgSearch width={30} />
            <p className="font-semibold pl-2 w-[184px]">Image Search</p>
            <p className="w-[360px] tex-sm">Search by lmage (Coming)</p>
          </div>

          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-9 items-center mt-6">
            <SvgNGUXLPRSearch width={30} />
            <p className="font-semibold pl-2 w-[184px]">LPR Search</p>
            <p className="w-[360px] tex-sm">Track Stolen Car Easily (Coming)</p>
          </div>

          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-9 items-center mt-6">
            <SvgAutoPilot width={30} />
            <p className="font-semibold pl-2 w-[184px]">Autopilot</p>
            <p className="w-[360px] tex-sm">
              Camera Recommendation for you should see
            </p>
          </div>

          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-9 items-center mt-6">
            <SvgNGUXMobileSOC width={30} />
            <p className="font-semibold pl-2 w-[184px]">Mobile SOC</p>
            <p className="w-[360px] tex-sm">Manage your business at hand</p>
          </div>
        </div>
      </div>
    </div>
  );
}
